<app-modal-container
  [bigSize]="false"
  [title]="title"
  [buttons]="modalButtons"
  [subtitle]="description"
  [innerModal]="innerModal"
  [applyActivated]="applyActivated"
  (applyButtonClicked)="close(true)"
  (dismissButtonClicked)="close(false)">
</app-modal-container>
